import React, { useState } from "react";
import get from "lodash/get";
import { useSelector } from "react-redux";
import { object } from "prop-types";
import ReCAPTCHA from "react-google-recaptcha";
import { InputField } from "../InputField";
import { isValidEmail } from "../../utils";
import { Toast } from "./Toast";
import { NEWSLETTER_API } from "../../../constants";
import "./news-letter.m.css";

const Newsletter = ({ story = {}, customStyle, newsLetterTextsStyle, isButtonPositionLower }) => {
  const [email, setEmail] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [toastMessage, setToastMessage] = useState("");
  const [toastStatus, setToastStatus] = useState("success");
  const [showToast, setShowToast] = useState(false);
  const recaptchaSiteKey = useSelector((state) =>
    get(state, ["qt", "config", "publisher-attributes", "google_recaptcha_site_key"], "")
  );

  const handleEmail = (event) => {
    setErrorMsg("");
    setEmail(event.target.value);
  };

  const handleSubmit = async (e) => {
    const emailInput = e.target.elements.email;
    if (emailInput.validity.valueMissing) {
      setErrorMsg("Please enter email!!!");
    } else if (emailInput.validity.typeMismatch) {
      setErrorMsg("Please enter valid email !!!");
    }
    e.preventDefault();

    if (!isValidEmail(email)) {
      setErrorMsg("Please enter valid email !!!");
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(recaptchaSiteKey, { action: "submit" }).then((token) => {
        submitForm(email, token);
      });
    });
  };

  const submitForm = async (email, captchaResponse) => {
    const yourMoneySection = story?.sections?.find((section) => section.slug === "your-money");
    const lists = yourMoneySection ? ["204"] : ["211"];
    const payload = {
      email: email,
      lists,
      captchaResponse: captchaResponse,
    };

    try {
      const response = await fetch(NEWSLETTER_API, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.response === "success") {
        setToastMessage("Thank you for subscribing to Gulf News!");
        setToastStatus("success");
      } else {
        setToastMessage("Something went wrong. Please try again.");
        setToastStatus("error");
      }
    } catch (error) {
      setToastMessage("Something went wrong. Please try again.");
      setToastStatus("error");
    }
    setEmail("");
    setShowToast(true);
  };

  return (
    <div styleName="news-letter-wrapper" style={customStyle}>
      <p style={newsLetterTextsStyle}>Sign up for the Daily Briefing</p>
      <p style={newsLetterTextsStyle}>Get the latest news and updates straight to your inbox</p>
      <form
        styleName={`signup-form ${isButtonPositionLower ? "signup-form-button-position" : ""}`}
        onSubmit={handleSubmit}
      >
        <InputField id="email" value={email} type="email" placeholder="Email address" required onChange={handleEmail} />
        <button type="submit">SIGN UP</button>
      </form>
      {errorMsg && <p style={{ fontWeight: "bold", textAlign: "center" }}> {errorMsg} </p>}

      {showToast && <Toast status={toastStatus} message={toastMessage} onClose={setShowToast} />}
      <ReCAPTCHA sitekey={recaptchaSiteKey} size="invisible" badge="bottomright" />
    </div>
  );
};

Newsletter.propTypes = {
  story: object,
};

export default Newsletter;
